<template>
    <access-denied v-if="accessDenied" :title="app_tela" />
    <div id="main" v-else>
        <loading :isLoading="isLoading" />
        <div class="page">
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t(app_tela) }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs" v-if="cameFrom == 'route'">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t(app_modulo) }}</a>
                                </li>
                                <li>
                                    <a class="a-inativo">{{ $t(app_submodulo) }}</a>
                                </li>
                                <li>
                                    <a aria-current="page">{{ $t(app_tela) }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            v-if="cameFrom != 'route'"
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="$emit('voltar', true)"
                        >
                            {{ $t('voltar') }}
                        </button>
                        <download-csv
                            ref="csvExportAllButton"
                            :data="objectListAll"
                            :fields="mapFildsToCsv()"
                            :labels="mapLabelToCsv()"
                            delimiter=";"
                            :name="getCsvName()"
                            :class="{ 'is-clickable': !isEmpty }"
                            v-if="objectListAll.length != 0"
                        >
                            <b-icon
                                icon="file-export"
                                :type="!isEmpty ? 'is-primary' : 'is-dark'"
                                size="is-medium"
                                class="is-medium"
                                v-tippy
                                :title="$t('exporta-registros-relatorio')"
                            />
                        </download-csv>
                        <div @click="getDataToExportAllCsv()" class="clicable" v-else>
                            <b-icon
                                icon="file-download"
                                :type="!isEmpty ? 'is-primary' : 'is-dark'"
                                size="is-medium"
                                class="is-medium"
                                v-tippy
                                :title="$t('exporta-registros-relatorio-solicitacao')"
                            />
                        </div>
                        <download-csv
                            :data="objectSelected"
                            :fields="mapFildsToCsv()"
                            :labels="mapLabelToCsv()"
                            delimiter=";"
                            :name="getCsvName()"
                            :class="{ 'is-clickable': objectSelected.length != 0 }"
                        >
                            <div class="contagem" v-if="objectSelected.length != 0">
                                <span>{{ objectSelected.length }}</span>
                            </div>
                            <b-icon
                                icon="file"
                                :type="objectSelected.length == 0 ? 'is-dark' : 'is-primary'"
                                size="is-medium"
                                class="is-medium"
                                v-tippy
                                :title="
                                    objectSelected.length == 0
                                        ? $t('necessario-selecionar-linhas')
                                        : $t('msg-tooltip-csv')
                                "
                            />
                        </download-csv>
                    </div>
                </div>

                <!-- PESQUISA E FILTROS -->
                <div class="dynamic-filter-bar mb-3">
                    <div class="dynamic-filter-bar-form form-columns-fit">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            :tooltipLabel="tooltipLabelSearch"
                            ref="search"
                        />

                        <!-- Slot de filtros -->
                        <slot name="top-filter" />
                    </div>
                    <div class="dynamic-filter-bar-actions">
                        <b-button
                            v-if="showLateralFilter"
                            class="mr-2"
                            type="is-primary"
                            icon-right="filter"
                            @click="showFilter = !showFilter"
                            v-tippy
                            :title="$t('filtros')"
                        />
                        <b-button
                            v-if="permissao.update"
                            type="is-primary"
                            icon-right="pencil"
                            @click="showParametrizacao = !showParametrizacao"
                            v-tippy
                            :title="$t('selecao-campos')"
                        />
                    </div>
                </div>

                <div class="registry-wrapper">
                    <!-- <div> -->
                    <empty-table-message v-if="isEmpty && loadedFiels" />
                    <!-- class="data-table" -->
                    <b-table
                        v-else-if="loadedFiels"
                        :data="objectList"
                        @sort="sortTable"
                        :checked-rows.sync="objectSelected"
                        :custom-is-checked="(selected, row) => selected.id === row.id"
                        checkable
                        backend-sorting
                        :hoverable="hoverable"
                        :bordered="bordered"
                    >
                        <b-table-column
                            v-for="(field, i) in table_fields"
                            :key="i"
                            :field="field.key"
                            :label="$t(field.key)"
                            :sortable="field.sortable"
                            :width="field.width"
                        >
                            <template v-slot="props">
                                <slot name="table-column" :props="props" :field="field">
                                    {{
                                        isNull(props.row[field.key]) ? '---' : props.row[field.key]
                                    }}
                                    <!-- 
                                    Modo de usar
                                    <template v-slot:table-column="{ props, field }">
                                        <strong v-if="field.key == 'codigo'">
                                            {{ props.row[field.key] }}
                                        </strong>
                                        <div v-else>
                                            {{ props.row[field.key] }}
                                        </div>
                                    </template>
                                    -->
                                </slot>
                            </template>
                        </b-table-column>
                    </b-table>

                    <!-- Slot antes da paginação -->
                    <slot name="footer" />

                    <PaginationViewer
                        v-if="loadedFiels"
                        class="mb-0"
                        :resetPagination="pagination.resetPagination"
                        :totalItems="pagination.totalRows"
                        :perPageOptions="pagination.perPageOptions"
                        :optionStarted="pagination.optionStarted"
                        @change="updatePagination"
                    />
                </div>
            </div>
        </div>

        <lateral-content
            :isLoading="isLoading"
            v-model="showFilter"
            footer
            v-if="showLateralFilter"
        >
            <template v-slot:footer-right>
                <b-button
                    type="is-warning is-silver"
                    icon-right="backspace"
                    @click="
                        objectSelected = [];
                        showFilter = false;
                    "
                    class="mr-2"
                    :disabled="isLoading"
                >
                    {{ $t('limpar') }} {{ $t('exportacao') }}
                </b-button>
                <b-button
                    type="is-warning is-silver"
                    icon-right="backspace"
                    @click="onClearFilters()"
                    class="mr-2"
                    :disabled="isLoading"
                >
                    {{ $t('limpar') }} {{ $t('filtros') }}
                </b-button>
                <b-button
                    type="is-primary"
                    icon-right="filter"
                    @click="
                        carregarDados();
                        showFilter = false;
                    "
                    :disabled="isLoading"
                >
                    {{ $t('filtrar') }}
                </b-button>
            </template>
            <!-- Slot antes da paginação -->
            <slot name="lateral-filter"></slot>
        </lateral-content>
        <parametrizacao-campos
            :codigounicotela="app_tela"
            :showParametrizacao="showParametrizacao"
            @fecharModal="showParametrizacao = false"
            @table_fields="manageStart($event)"
        />
    </div>
</template>

<script>
/*
Como usar
    <RelatorioAnaliticoComponentList
        app_modulo="promotor"
        app_submodulo="relatorio-analitico"
        app_tela="relatorio-ruptura"
        :objectList="rupturaList"
        :objectListAll="rupturaListAll"
        :isEmpty="isEmpty"
        :isLoading="isLoading"
        :isDataStarted="isDataStarted"
        :pagination="pagination"
        tooltipLabelSearch="msg-busca-ruptura"
        showLateralFilter
        :cameFrom="cameFrom"
        @filtersReset="filtersReset = $event"
        @loadedFiels="loadedFiels = $event"
        @carregarDados="carregarDados($event)"
        @carregarDadosExportAll="carregarDados($event, true)"
        @search="onSearch($event)"
        @clearFilter="clearFilter()"
        @orderColumn="pagination.orderColumn = $event"
        @orderDirection="pagination.orderDirection = $event"
        @perPage="pagination.perPage = $event"
        @currentPage="pagination.currentPage = $event"
        @isLoading="isLoading = $event"
        @voltar="$emit('voltar', $event)"
    />
Página onde foi implementado:
    src\components\promotor\relatorio-analitico\relatorio-ruptura\RelatorioRupturaList.vue
chamado
    #90320
Descrição
    Facilitador para criação de listágens sem subpáginas 
    e com exportação por csv sem chamada ao server
*/
export default {
    props: {
        // se veio da página ou por componente
        cameFrom: {
            type: String,
            default: 'route',
        },
        // Lista de objetos para exibição
        objectList: {
            type: Array,
            default: () => [],
        },
        // Lista de objetos para exportação total
        objectListAll: {
            type: Array,
            default: () => [],
        },
        // Se a lsitagem está vazia
        isEmpty: {
            type: Boolean,
            default: true,
        },
        // Dados de paginação
        pagination: {
            type: Object,
            default: () => {
                return {
                    resetPagination: false,
                    perPageOptions: [10, 25, 50, 100],
                    optionStarted: 0,
                    perPage: null,
                    totalRows: 0,
                    currentPage: 1,
                    orderColumn: 'id',
                    orderDirection: 'asc',
                };
            },
        },
        // Se está em andamento
        isLoading: {
            type: Boolean,
            default: false,
        },
        // ex promotor
        app_modulo: {
            type: String,
            default: null,
        },
        // ex relatorio-analitico
        app_submodulo: {
            type: String,
            default: null,
        },
        // ex relatorio-ruptura
        app_tela: {
            type: String,
            default: null,
        },
        // Info de busca
        tooltipLabelSearch: {
            type: String,
            default: null,
        },
        // se a lsitagem está vazia
        showLateralFilter: {
            type: Boolean,
            default: true,
        },
        bordered: {
            type: Boolean,
            default: true,
        },
        hoverable: {
            type: Boolean,
            default: true,
        },
        // Carregou dados do componente pai pela primeira vez
        isDataStarted: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            permissao: this.hasPermissionAccess(this.app_modulo, this.app_submodulo, this.app_tela),
            accessDenied: false,
            objectSelected: [],
            table_fields: [],
            debouncedOnSearch: this.debounce(this.onSearch, 500),
            showFilter: false,
            showParametrizacao: false,
            loadedFiels: false,
            dateFields: ['data', 'datainicio', 'datafim', 'datainicial', 'datafinal'],
        };
    },
    watch: {
        objectListAll: {
            deep: true,
            handler: function (value) {
                if(value.length) {
                    this.$root.confirm({
                        message: this.$t('dados-carregados-relatorio-exportacao'),
                        onConfirm: (_) => this.$refs.csvExportAllButton.$el.click(),
                    });
                }
            }
        }
    },
    created() {
        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            this.carregarDados();
        }
    },
    methods: {
        carregarDados(currentPage = 1) {
            this.$emit('carregarDados', currentPage);
        },
        getDataToExportAllCsv() {
            this.$emit('carregarDadosExportAll');
        },
        getCsvName() {
            let name =
                'relatorio-' +
                this.app_tela +
                '_' +
                this.$moment().format('YYYY-MM-DD_HH-mm-ss') +
                '.csv';
            return name;
        },
        mapFildsToCsv() {
            let fieldsArray = this.table_fields.map((m) => m.key);
            return fieldsArray;
        },
        mapLabelToCsv() {
            let lablesObject = this.table_fields.reduce((acc, item) => {
                acc[item.key] = this.$t(item.label);
                return acc;
            }, {});
            return lablesObject;
        },
        manageStart(table_fields) {
            this.table_fields = table_fields.map((m) => {
                if (this.dateFields.includes(m.key) || m.key.includes('datahora')) {
                    m.width = 100;
                }
                if (m.key.includes('latitude') || m.key.includes('longitude')) {
                    m.width = 100;
                }
                return m;
            });
            if (!this.loadedFiels) {
                this.loadedFiels = true;
                this.$emit('loadedFiels', this.loadedFiels);
                if(this.isDataStarted) this.$emit('isLoading', false);
            }
        },
        updatePagination(value) {
            this.$emit('resetPagination', false);
            this.$emit('perPage', value.perPage);
            this.$emit('currentPage', value.currentPage);
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.$emit('orderColumn', field);
            this.$emit('orderDirection', order);
            this.carregarDados();
        },
        onSearch(value) {
            this.$emit('search', this.removeAcentos(value));
        },
        onClearFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: () => this.clearFilter(),
            });
        },
        clearFilter() {
            this.$emit('filtersReset', true);
            this.$refs.search.cleanSearch();
            this.$emit('clearFilter');

            setTimeout(() => {
                this.$emit('filtersReset', false);
                this.showFilter = false;
            }, 1000);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .b-table,
::v-deep .table-wrapper {
    height: 100%;
}

#main {
    background-color: $bg-color;
    border-radius: 5px;
    padding: 5px 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;

        .situacao-select div,
        .produtivo-select div {
            height: 40px;
        }
        .contagem {
            position: absolute;
            right: 0;
            top: 0;
            background-color: $green-alert;
            border-radius: 50%;
            line-height: 1;
            min-width: 18px;
            height: 18px;
            margin-top: 0px;
            margin-right: -4px;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                color: #fff;
                font-weight: bold;
                font-size: 10px;
                padding: 5px;
            }
        }
    }
}
</style>
